module.exports = __webpack_public_path__ + "static/media/K3.8634d763.png";